import { render, staticRenderFns } from "./C.vue?vue&type=template&id=2de93bd1&"
import script from "./C.vue?vue&type=script&lang=js&"
export * from "./C.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de93bd1')) {
      api.createRecord('2de93bd1', component.options)
    } else {
      api.reload('2de93bd1', component.options)
    }
    module.hot.accept("./C.vue?vue&type=template&id=2de93bd1&", function () {
      api.rerender('2de93bd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/configurator/C.vue"
export default component.exports